import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { coworkersService } from "../../../service/coworkersService";
import BDetailsPage from "../../../components/crud/BDetailsPage";
import BErrorIndicator from "../../../components/indicators/BErrorIndicator";
import BLoadingIndicator from "../../../components/indicators/BLoadingIndicator";

export default function CoworkersDetails() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [coworker, setCoworker] = useState(null);
  const history = useHistory();
  const { id } = useParams();

  useEffect(() => {
    coworkersService
      .getCoworkerById(id)
      .then((res) => setCoworker(res.data))
      .catch((err) => {
        if (err.response.status === 404) {
          pushBack();
        }
        setError(true);
      })
      .finally((_) => {
        setIsLoading(false);
      });
  }, [id]);

  const handleDelete = () => {
    coworkersService.deleteCoworker(id).then(() => {
      pushBack();
    });
  };

  const handleBlock = () => {
    coworkersService.blockCoworker(id).then(() => {
      pushBack();
    });
  };

  const handleUnblock = () => {
    coworkersService.unblockCoworker(id).then(() => {
      pushBack();
    });
  };

  const pushBack = () => {
    history.push(`/coworkers`);
  };

  if (isLoading) {
    return <BLoadingIndicator />;
  } else if (error) {
    return <BErrorIndicator />;
  }

  return (
    <BDetailsPage
      data={coworker}
      handleDelete={handleDelete}
      handleBlock={handleBlock}
      handleUnblock={handleUnblock}
      isBlocked={coworker?.isBlocked}
    />
  );
}
